
const C = 'CUSTOMER_PO.CURRENT.SHOW_IMAGES_GALLERY';

export default {
  SHOW_MODAL: `${C}.SHOW_MODAL`,
  HIDE_MODAL: `${C}.HIDE_MODAL`,

  RESET_DATA: `${C}.RESET_DATA`,
};
